module.exports = "/packs/media/digitalized_orders/calendar-b56f7cd9.png";